import { SpotlightCurrentVenueConfig } from '@ivy-monorepo/shared'

type SpotlightCurrentVenueSettingsProps = {
  value: SpotlightCurrentVenueConfig
  onChange: (value: SpotlightCurrentVenueConfig) => void
}

const SpotlightCurrentVenueSettings = ({ value, onChange }: SpotlightCurrentVenueSettingsProps) => (
  <div className="spotlight-current-venue-settings">
    <div className="feature-flag-subtitle feature-flag-subtitle-spaced">
      Only applies when the user has an active check-in (<code>current_venue_id</code>). These options affect that venue
      only — all other candidates still follow search radius and eligibility rules.
    </div>
    <label className="ticker-checkbox-field">
      <input
        type="checkbox"
        checked={value.alwaysInclude}
        onChange={e => onChange({ ...value, alwaysInclude: e.target.checked })}
      />
      <span className="ticker-checkbox-field__text">
        <span className="ticker-checkbox-field__label">Always include current check-in in the ticker</span>
        <span className="feature-flag-subtitle ticker-checkbox-field__help">
          Fetches the checked-in venue by ID and appends it to candidates if it was filtered out by radius or
          eligibility. Venue availability dates still apply.
        </span>
      </span>
    </label>
    <label className="ticker-checkbox-field">
      <input
        type="checkbox"
        checked={value.pinFirst}
        onChange={e => onChange({ ...value, pinFirst: e.target.checked })}
      />
      <span className="ticker-checkbox-field__text">
        <span className="ticker-checkbox-field__label">Pin current check-in first in ranking</span>
        <span className="feature-flag-subtitle ticker-checkbox-field__help">
          Inserts <code>currentVenue</code> as the first sort criterion, before the activity priority list below.
          Independent of always-include — a pinned venue can still be missing if it was never a candidate and
          always-include is off.
        </span>
      </span>
    </label>
  </div>
)

export default SpotlightCurrentVenueSettings
